/*
 * @Author: weixiuting weixiuting@qq.com
 * @Date: 2022-12-13 17:11:34
 * @LastEditors: weixiuting weixiuting@qq.com
 * @LastEditTime: 2023-07-07 09:31:24
 * @FilePath: \plantingSubsidy_web_update\src\utils\request.js
 * @Description: 台账服务相关配置
 */

import axios from 'axios'
import {
  message,
  Modal,
  notification
} from 'ant-design-vue'
import moment from 'moment'
import store from '../store'
import db from 'utils/localstorage'
import platformName from '@/utils/platform'
moment.locale('zh-cn')
// 统一配置
let FEBS_REQUEST = axios.create({
  //  baseURL: process.env.BASE_API1,
   baseURL: window.global_config.BASE_URL1, 
  // responseType: 'json', // 默认
  // timeout: 20000,
  validateStatus (status) {
    // 200 外的状态码都认定为失败
    return status === 200
  }
  // withCredentials: false,
  // transformResponse: data => {
  //   console.log('实际返回data:', data)
  //   try {
  //     return JSON_BIG.parse(data)
  //   } catch (err) {
  //     console.log(err)
  //     return JSON.parse(data)
  //   }
  // }
  // transformResponse: [function (data, headers) {
  //   // 对发送的 data 进行任意转换处理

  //   console.log('实际返回data:', data)
  //   return data
  // }]

})

// 拦截请求
FEBS_REQUEST.interceptors.request.use((config) => {
  let expireTime = store.state.account.expireTime
  let now = moment().format('YYYYMMDDHHmmss')
  // 让token早10秒种过期，提升“请重新登录”弹窗体验
  if (now - expireTime >= -10) {
    Modal.error({
      title: '登录已过期',
      content: '很抱歉，登录已过期，请重新登录',
      okText: '重新登录',
      mask: false,
      onOk: () => {
        return new Promise((resolve, reject) => {
          db.clear()
          location.reload()
        }).catch(function (reason) {
          // console.log('catch:', reason)
        })
      }
    })
  }
  // 有 token就带上
  if (store.state.account.token) {
    config.headers.Authentication = store.state.account.token
  }
  return config
}, (error) => {
  return Promise.reject(error)
})

// 拦截响应
FEBS_REQUEST.interceptors.response.use((config) => {
  return config
}, (error) => {
  if (error.response) {
    let errorMessage = error.response.data === null ? '系统内部异常，请联系网站管理员' : error.response.data.message
    switch (error.response.status) {
      case 404:
        notification.error({
          message: '系统提示',
          description: '很抱歉，资源未找到',
          duration: 4
        })
        break
      case 403:
      case 401:
        notification.warn({
          message: '系统提示',
          description: '很抱歉，您无法访问该资源，可能是因为没有相应权限或者登录已失效',
          duration: 4
        })
        break
      case 500:
        // 单独处理投保单导出文件提示异常

        let requestUrl = error.response.request.responseURL
        if (requestUrl.indexOf('/insurance/ledgerPlantShot/getExcel') !== -1) {
          // console.log(error.response.data)
          if (error.response.data.type === 'application/json') {
            const reader = new FileReader()
            reader.readAsText(error.response.data)
            reader.onload = e => {
              const { message } = JSON.parse(e.target.result)
              notification.error({
                message: '系统提示',
                description: message,
                duration: 4
              })
            }
          }
        } else {
          if (error.response.data && error.response.data.message) {
            notification.error({
              message: error.response.data.message || '系统提示',
              description: error.response.data.message,
              duration: 4
            })
          }
        }

        // else if (requestUrl.indexOf('/insurance/ledgerPlantShot/importExcel') !== -1) {
        //   if (error.response.data && error.response.data.message) {
        //     notification.error({
        //       message: '系统提示',
        //       description: error.response.data.message,
        //       duration: 4
        //     })
        //   }
        // } else if (requestUrl.indexOf('/insurance/ledgerPlantShot/importTwoInOneExcel') !== -1) {
        //   // 单独处理村投保单 二合一采集表导入
        //   if (error.response.data && error.response.data.message) {
        //     notification.error({
        //       message: '系统提示',
        //       description: error.response.data.message,
        //       duration: 4
        //     })
        //   }
        // }

        break
      default:
        notification.error({
          message: '系统提示',
          description: errorMessage,
          duration: 4
        })
        break
    }
  }

  return Promise.reject(error)
})

const request = {
  post (url, params, option) {
    if (option && option.type === 'json') {
      return FEBS_REQUEST.post(url, params, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
    } else if (option && option.type === 'formData') {
      return FEBS_REQUEST.post(url, params, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      })
    } else {
      return FEBS_REQUEST.post(url, params, {
        transformRequest: [(params) => {
          let result = ''
          Object.keys(params).forEach((key) => {
            if (!Object.is(params[key], undefined) && !Object.is(params[key], null)) {
              result += encodeURIComponent(key) + '=' + encodeURIComponent(params[key]) + '&'
            }
          })
          return result
        }],
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      })
    }
  },
  post_json (url, params) {
    return FEBS_REQUEST.post(url, params, {
      headers: {
        'Content-Type': 'application/json;charset=utf-8'
      }
    }).then(res => {
      if (res.status == 200) {
        // message.success('修改成功')
      } else {
        // message.error('修改失败')
      }
    })
  },
  put (url, params) {
    return FEBS_REQUEST.put(url, params, {
      transformRequest: [(params) => {
        let result = ''
        Object.keys(params).forEach((key) => {
          if (!Object.is(params[key], undefined) && !Object.is(params[key], null)) {
            result += encodeURIComponent(key) + '=' + encodeURIComponent(params[key]) + '&'
          }
        })
        return result
      }],
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
  },

  get (url, params) {
    let _params
    if (Object.is(params, undefined)) {
      _params = ''
    } else {
      _params = '?'
      for (let key in params) {
        if (params.hasOwnProperty(key) && params[key] !== null) {
          _params += `${key}=${params[key]}&`
        }
      }
    }
    return FEBS_REQUEST.get(`${url}${_params}`)
  },
  delete (url, params) {
    let _params
    if (Object.is(params, undefined)) {
      _params = ''
    } else {
      _params = '?'
      for (let key in params) {
        if (params.hasOwnProperty(key) && params[key] !== null) {
          _params += `${key}=${params[key]}&`
        }
      }
    }
    return FEBS_REQUEST.delete(`${url}${_params}`)
  },

  export (url, params = {}) {
    message.loading('导出数据中')
    return FEBS_REQUEST.post(url, params, {
      transformRequest: [(params) => {
        let result = ''
        Object.keys(params).forEach((key) => {
          if (!Object.is(params[key], undefined) && !Object.is(params[key], null)) {
            result += encodeURIComponent(key) + '=' + encodeURIComponent(params[key]) + '&'
          }
        })
        return result
      }],
      responseType: 'blob'
    }).then((r) => {
      console.log('文件', r)

      const content = r.data

      const blob = new Blob([content])
      let type = r.data.type || ''

      let fileName = ''
      if (params && params.oldName) {
        // 保留原来文件名称
        // fileName=content.name
        fileName = decodeURI(r.headers['filename'])
        // console.log('文件名：', fileName)
        // fileName = '新农镇-和平村村委会水稻(2023)_3.xlsx'
      } else {
        // 给默认名字
        if (type.indexOf('text') !== -1) {
          fileName = `${new Date().getTime()}_导出结果.txt`
        } else {
          fileName = `${new Date().getTime()}_导出结果.xlsx`
        }
      }

      if ('download' in document.createElement('a')) {
        const elink = document.createElement('a')
        elink.download = fileName
        elink.style.display = 'none'
        elink.href = URL.createObjectURL(blob)
        document.body.appendChild(elink)
        elink.click()
        URL.revokeObjectURL(elink.href)
        document.body.removeChild(elink)
      } else {
        navigator.msSaveBlob(blob, fileName)
      }
    }).catch((r) => {
      // console.error(r)
      message.error('导出失败')
    })
  },
  exportZip (url, params = {}) {
    message.loading('导出数据中')
    return FEBS_REQUEST.post(url, params, {
      transformRequest: [(params) => {
        let result = ''
        Object.keys(params).forEach((key) => {
          if (!Object.is(params[key], undefined) && !Object.is(params[key], null)) {
            result += encodeURIComponent(key) + '=' + encodeURIComponent(params[key]) + '&'
          }
        })
        return result
      }],
      responseType: 'blob'
    }).then((r) => {
      const content = r.data
      const blob = new Blob([content])
      const fileName = `${new Date().getTime()}_导出结果.zip`
      if ('download' in document.createElement('a')) {
        const elink = document.createElement('a')
        elink.download = fileName
        elink.style.display = 'none'
        elink.href = URL.createObjectURL(blob)
        document.body.appendChild(elink)
        elink.click()
        URL.revokeObjectURL(elink.href)
        document.body.removeChild(elink)
      } else {
        navigator.msSaveBlob(blob, fileName)
      }
    }).catch((r) => {
      // console.error(r)
      message.error('导出失败')
    })
  },
  download (url, params, filename) {
    message.loading('文件传输中')
    return FEBS_REQUEST.post(url, params, {
      transformRequest: [(params) => {
        let result = ''
        Object.keys(params).forEach((key) => {
          if (!Object.is(params[key], undefined) && !Object.is(params[key], null)) {
            result += encodeURIComponent(key) + '=' + encodeURIComponent(params[key]) + '&'
          }
        })
        return result
      }],
      responseType: 'blob'
    }).then((r) => {
      const content = r.data
      const blob = new Blob([content])
      if ('download' in document.createElement('a')) {
        const elink = document.createElement('a')
        elink.download = filename
        elink.style.display = 'none'
        elink.href = URL.createObjectURL(blob)
        document.body.appendChild(elink)
        elink.click()
        URL.revokeObjectURL(elink.href)
        document.body.removeChild(elink)
      } else {
        navigator.msSaveBlob(blob, filename)
      }
    }).catch((r) => {
      // console.error(r)
      message.error('下载失败')
    })
  },
  upload (url, params) {
    return FEBS_REQUEST.post(url, params, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }
}

export default request



// WEBPACK FOOTER //
// ./src/utils/request.js